import { RouteComponentProps, withRouter } from 'react-router-dom';
import TransferTable from './TransferTable';

export interface Props extends RouteComponentProps {}

export default withRouter(TransferTable as any);
